import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { useWindowSize } from "go-core/components/useWindowSize";
import { organizationApi } from "../../../../../../../../services/Api/Organization/organizationApi";
import {
	AvailableSubscriptionContentsApi,
	SubscriptionInvoiceApi,
	SubscriptionsApi,
	UpdateSubscriptionsApi,
} from "../../../../../../../../services/Api/Subscription/subscriptionTypes";
import { CustomerApi, OrganizationMeApi } from "../../../../../../../../services/Api/types";
import { selectOrganization } from "../../../../../../../../services/organizations/selectors";
import { parseSubscriptionsToRequest } from "../FormNew/services";
import SubscriptionsInvoiceDetails from "../Preview/SubscriptionsInvoiceDetails";
import SubscriptionsPayment from "../Preview/SubscriptionsPayment";
import SubscriptionNeedHelp from "../SubscriptionNeedHelp";
import SubscriptionSummaryPreviewSubscriptionDetails from "./SubscriptionSummaryPreviewSubscriptionDetails";
import SubscriptionSummaryPreviewSubscriptionDetailsMobile from "./SubscriptionSummaryPreviewSubscriptionDetailsMobile";

interface Props {
	estimate: SubscriptionsApi;
	original: SubscriptionsApi;
	meDetails: OrganizationMeApi;
	customer: CustomerApi | undefined;
	form: UseFormReturn<UpdateSubscriptionsApi>;
	configs: AvailableSubscriptionContentsApi;
	invoices: SubscriptionInvoiceApi[];
	termsNamesToAccept: string[];
}

const SubscriptionSummaryPreview = (props: Props) => {
	const [updatedMeDetails, setUpdatedMeDetails] = useState(props.meDetails);
	const { getValues } = props.form;
	const organization = useSelector(selectOrganization);
	const { addFlash } = useFlash();
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const isMobile = useWindowSize().isMobile;

	const handleSave = async () => {
		try {
			setLoading(true);
			const values = getValues();
			const newValues = {
				...values,
				subscriptions: parseSubscriptionsToRequest(props.configs, values),
			};

			const promises = [
				await organizationApi.updateSubscription(newValues),
				...props.termsNamesToAccept.map((termsName) => organizationApi.acceptTerms(termsName)),
			];
			await Promise.all(promises);
			addFlash({
				type: "success",
				msg: "Zapisano",
			});
			setLoading(false);
			history.push(`/${organization.id}/subscriptions`);
		} catch (e) {
			setLoading(false);
			handleError.alert(e, addFlash);
		}
	};

	return (
		<div className="subscription-summary-preview">
			{isMobile && (
				<>
					<SubscriptionsPayment invoices={props.invoices} />
					<SubscriptionsInvoiceDetails
						meDetails={updatedMeDetails}
						customer={props.customer}
						onFetchOrganizationMeDetails={setUpdatedMeDetails}
					/>
				</>
			)}
			{isMobile ? (
				<SubscriptionSummaryPreviewSubscriptionDetailsMobile
					original={props.original}
					compare={props.estimate}
					handleSave={handleSave}
					loading={loading}
					config={props.configs}
				/>
			) : (
				<SubscriptionSummaryPreviewSubscriptionDetails
					original={props.original}
					compare={props.estimate}
					handleSave={handleSave}
					loading={loading}
					config={props.configs}
				/>
			)}
			{!isMobile && (
				<div className="row">
					<div className={"col-lg-6 mb-2"}>
						<SubscriptionsPayment invoices={props.invoices} />
					</div>
					<div className={"col-lg-6 mb-2"}>
						<SubscriptionsInvoiceDetails
							meDetails={updatedMeDetails}
							customer={props.customer}
							onFetchOrganizationMeDetails={setUpdatedMeDetails}
						/>
					</div>
				</div>
			)}
			{isMobile && (
				<Card className="subscription-info-card mt-2">
					<Card.Body>
						<SubscriptionNeedHelp />
					</Card.Body>
				</Card>
			)}
		</div>
	);
};

export default SubscriptionSummaryPreview;
